import { Route, Routes } from "react-router-dom";
import TicketsPage from "../../pages/features/tickets/TicketsPage";
import CategoriesPage from "../../pages/features/tickets/CategoriesProblemPage";
import TicketDetailsPage from "../../pages/features/tickets/TicketDetailsPage";



export default function TicketNav() {
  return (
    <Routes>

      <Route path="/" element={<TicketsPage />} />
      <Route path="/details/:id" element={<TicketDetailsPage />} />

      <Route path="/categories-problem" element={<CategoriesPage />} />

    </Routes>
  );
}
